(function ($) {
    "use strict";
    $(function () {

        $('.js-tab').on('click', function () {
            $('.js-tab.active').removeClass('active');
            $(this).addClass('active');
            var tabIndex = $(this).data('index');
          
            $('.js-tab-container.active').parent().css('min-height', $('.js-tab-container.active').height());
            $('.js-tab-container.active').fadeOut('400', function () {
                $('.js-tab-container.active').removeClass('active');
                $('.js-tab-container').eq(tabIndex).fadeIn('400').addClass('active');
                $('.js-tab-container.active').parent().css('min-height', '100%');
            });
        });

    });

})(jQuery);